import { PlusOutlined } from "@ant-design/icons";
import { Breadcrumb, Flex, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { Button, CardContainer } from "components/elements";
import { MainLayout } from "components/layouts";
import WarningLetterRequestTable from "../table/requestTables/WarningLetterRequestTable";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import WarningLetterForm from "features/myDocument/components/WarningLetterForm";
import useWarningLetterRequest from "../hook/useWarningLetterRequest";
import { useMemo } from "react";

const WarningLetterRequestContent = () => {
    const { t } = useTranslation();
    const {
        isLoading,
        dataSource,
        pagination,
        onChange,
        isModalOpen,
        editingRecord,
        onOpenCreateModal,
        onEdit,
        modalMode,
        onView,
        onCloseModal,
        onCancelRequest,
        onSaveDraft,
        onViewPdf,
        onSubmit,
        onPreviewPdf,
        modifiedEmployeeOptions,
        modifiedReasonOptions, // TODO: rename → modifiedCompanyRegulationOptions
    } = useWarningLetterRequest();
    const filteredData = useMemo(() => {
        return dataSource.filter(
            item => item.approveStatusEn === "Approved"
        );
    }, [dataSource]);
    return (
        <MainLayout>
            <Flex vertical style={{ rowGap: 40 }}>
                <Flex justify="space-between" align="center">
                    <Flex vertical>
                        <Breadcrumb
                            items={[
                                { title: t("home.header"), href: "/" },
                                { title: t("document_request.header"), href: "" },
                                { title: t("warning_letter.header") },
                            ]}
                        />
                        <h2>{t("warning_letter.header")}</h2>
                    </Flex>
                </Flex>

                <CardContainer width="100%" height="fit-content">
                    <WarningLetterRequestTable
                        isLoading={isLoading}
                        dataSource={filteredData}
                        pagination={{
                            ...pagination,
                            total: filteredData.length,
                        }}
                        onChange={onChange}
                        onEdit={onEdit}
                        onView={onView}
                        onViewPdf={onViewPdf}
                        onCancelRequest={onCancelRequest}
                    />
                </CardContainer>

                <Modal
                    open={isModalOpen}
                    onCancel={onCloseModal}
                    footer={null}
                    width={1000}
                    destroyOnClose
                    title={
                        <div>
                            <div style={{ fontSize: 20, fontWeight: 600 }}>
                                {t("warning_letter.header")}
                            </div>
                            {editingRecord && (
                                <div style={{ fontSize: 14, fontWeight: 400, color: "#667085" }}>
                                    {t("warning_letter.view_title") || "ดูรายละเอียดหนังสือเตือน"}
                                </div>
                            )}
                        </div>
                    }
                >
                    <WarningLetterForm
                        initialValues={editingRecord || {}}
                        modalType={modalMode || "create"}
                        employeeOptions={modifiedEmployeeOptions}
                        companyRegulationOptions={modifiedReasonOptions}
                        onDraft={onSaveDraft}
                        onSubmit={onSubmit}
                        onDownload={onViewPdf}
                        onCancel={onCloseModal}
                        isDownloading={isLoading}
                        onPreviewPdf={onPreviewPdf}
                    />
                </Modal>
            </Flex>
        </MainLayout>
    );
};

export default WarningLetterRequestContent;